import { render, staticRenderFns } from "./AssetImageUploadInfo.vue?vue&type=template&id=204843d7&lang=pug"
import script from "./AssetImageUploadInfo.vue?vue&type=script&lang=js"
export * from "./AssetImageUploadInfo.vue?vue&type=script&lang=js"
import style0 from "./AssetImageUploadInfo.vue?vue&type=style&index=0&id=204843d7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports